<template>
    <div class="insightBox">
        <div class="insightTitle">
            <indexTitle :title="dataInfo.moduleTitle" @goMore="goMore"></indexTitle>
        </div>
        <el-carousel :interval="4000" type="card" height="720px">
            <el-carousel-item v-for="item in 1" :key="item">
                
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import indexTitle from "./indexTitle.vue"
export default {
    components: {
        indexTitle,

    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return {
                    is_show: 0,
                    list: [],
                    moduleTitle: '',
                }
            },
        },
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        goMore() {

        },
    }
}
</script>

<style>

</style>

<style scoped lang="scss">
.insightBox {
    background: #fff;
    margin-bottom: 50px;

}

@media screen and (max-width:1200px) {}
</style>